(function () {

  const nvznAppData = JSON.parse(document.getElementById('nvzn-app-data').textContent);
  if (!nvznAppData) return console.error('[NVZN] nvznAppData not found');
  log('nvznAppData:', nvznAppData);

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }
    document.querySelectorAll('.nvzn3d-arbutton').forEach((button) => {
      button.addEventListener('click', function () {
        const selectedVariant = getSelectedVariant();
        if (!selectedVariant) return console.error('[NVZN] Unable to determine selected variant');
        const arImage = nvznAppData.product.arImage || null;
        if (!arImage) return console.error('[NVZN] Unable to determine AR image');
        const dimensions = extractDimensions(selectedVariant.option1);
        log('AR Image:', arImage);
        log('Dimensions:', dimensions);
        handleFloorPreview(dimensions, arImage);
      });
    });
  }

  function handleFloorPreview(dimensions, arImage) {
    Nvzn3D.displayFloorPreview({
      clientId: nvznAppData.app.nvznFloorClientID,
      imageUrl: arImage,
      width: dimensions.width,
      length: dimensions.length,
      units: dimensions.units,
      language: nvznAppData.app.locale || 'en',
    });
  }

  function getSelectedVariant() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant') || nvznAppData.product.selectedOrFirstAvailableVariantID.toString();
    if (!variantId) return console.error('[NVZN] Unable to determine variant ID');
    const variant = nvznAppData.product.variants.find((v) => v.id.toString() === variantId);
    if (!variant) return console.error(`[NVZN] Variant with ID ${variantId} not found`);
    return variant || null;
  }

  function extractDimensions(sizeString) {
    // Split the input string by 'x', 'X', or '×' (times symbol) and trim whitespace
    const dimensions = sizeString.split(/[xX×]/).map(dim => dim.trim());
    // Parse width and length from the dimensions array
    const width = parseInt(dimensions[0], 10);
    const length = parseInt(dimensions[1], 10);
    // Return the dimensions as an object
    return { width, length, units: 'cm', shape: 'rectangle' }; // Assuming units are in cm
  }

  function log(...args) {
    if (nvznAppData.app && nvznAppData.app.logging) {
      console.log('[NVZN]', ...args);
    }
  }

  init();
})();